(() => {
  const widget = document.getElementById('judgeme_product_reviews');
  const section = widget?.closest('.story-apps--native-reviews');
  if (!widget || !section) return;

  let controls;
  let button;
  let status;
  let loading = false;
  let archived = [];
  let archivedIds = new Set();
  let expectedPage = 0;
  let preservedScroll;
  let previousScrollBehavior;
  let timeout;
  let scheduled = false;

  const reviews = () => widget.querySelector('.jdgm-rev-widg__reviews');
  const reviewCards = list => [...list.children].filter(child => child.classList.contains('jdgm-rev'));
  const reviewId = card => card.dataset.reviewId || card.textContent.trim();
  const nextPage = () => widget.querySelector('.jdgm-paginate__next-page');
  const currentPage = () => Number(widget.querySelector('.jdgm-paginate .jdgm-curt')?.dataset.page || 1);
  const loadReviewImages = list => {
    for (const image of list.querySelectorAll('img[data-src]:not([src])')) {
      image.loading = 'lazy';
      image.decoding = 'async';
      image.src = image.dataset.src;
    }
  };
  const lockScrollBehavior = () => {
    const root = document.documentElement;
    if (previousScrollBehavior === undefined) previousScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
  };
  const unlockScrollBehavior = () => {
    if (previousScrollBehavior === undefined) return;
    document.documentElement.style.scrollBehavior = previousScrollBehavior;
    previousScrollBehavior = undefined;
  };
  const restoreScroll = clearAfter => {
    if (!preservedScroll) return;
    const position = preservedScroll;
    const applyPosition = () => {
      window.scrollTo(position.left, position.top);
    };
    requestAnimationFrame(() => {
      applyPosition();
      requestAnimationFrame(applyPosition);
    });
    if (clearAfter) {
      setTimeout(applyPosition, 80);
      setTimeout(applyPosition, 240);
      setTimeout(applyPosition, 500);
      setTimeout(applyPosition, 900);
      setTimeout(unlockScrollBehavior, 1200);
    }
    if (clearAfter) preservedScroll = null;
  };

  const releaseNativePagination = () => {
    restoreScroll(true);
    loading = false;
    clearTimeout(timeout);
    section.classList.remove('cps-review-controlled');
    if (controls) controls.hidden = true;
  };

  const update = () => {
    const list = reviews();
    if (!list || !controls) return;
    list.id = 'cps-native-review-list';
    loadReviewImages(list);

    if (loading && currentPage() >= expectedPage) {
      const incoming = reviewCards(list);
      if (incoming.some(card => !archivedIds.has(reviewId(card)))) {
        const incomingIds = new Set(incoming.map(reviewId));
        const previous = document.createDocumentFragment();
        for (const card of archived) {
          if (!incomingIds.has(reviewId(card))) previous.append(card);
        }
        list.prepend(previous);
        loadReviewImages(list);
        restoreScroll(true);
        archived = [];
        archivedIds.clear();
        loading = false;
        clearTimeout(timeout);
        status.textContent = `Showing ${reviewCards(list).length} customer reviews.`;
      }
    }

    button.hidden = !nextPage();
    button.disabled = loading;
    button.textContent = loading ? 'Loading customer reviews…' : 'Show more customer reviews';
  };

  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };

  const connect = () => {
    if (!reviews() || !widget.querySelector('.jdgm-paginate')) return false;
    controls = document.createElement('div');
    controls.className = 'cps-review-controls';
    button = document.createElement('button');
    button.className = 'cps-review-more';
    button.type = 'button';
    button.setAttribute('aria-controls', 'cps-native-review-list');
    status = document.createElement('p');
    status.className = 'cps-review-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    controls.append(button, status);
    section.querySelector('.section-padding')?.append(controls);
    section.classList.add('cps-review-controlled');

    button.addEventListener('click', () => {
      if (loading) return;
      const list = reviews();
      const next = nextPage();
      if (!list || !next) return;
      button.blur();
      lockScrollBehavior();
      archived = reviewCards(list);
      archivedIds = new Set(archived.map(reviewId));
      expectedPage = Number(next.dataset.page);
      preservedScroll = {left: window.scrollX, top: window.scrollY};
      loading = true;
      update();
      next.click();
      restoreScroll(false);
      timeout = setTimeout(releaseNativePagination, 10000);
    });

    widget.addEventListener('change', event => {
      if (!event.target.closest('.jdgm-sort-dropdown')) return;
      archived = [];
      archivedIds.clear();
      loading = false;
      clearTimeout(timeout);
      preservedScroll = null;
      unlockScrollBehavior();
      status.textContent = '';
      scheduleUpdate();
    });
    widget.addEventListener('click', event => {
      if (!event.target.closest('.jdgm-histogram__row, .jdgm-rev-widg__sort-wrapper')) return;
      archived = [];
      archivedIds.clear();
      loading = false;
      clearTimeout(timeout);
      preservedScroll = null;
      unlockScrollBehavior();
      status.textContent = '';
      scheduleUpdate();
    });

    new MutationObserver(scheduleUpdate).observe(widget, {childList: true, subtree: true});
    update();
    return true;
  };

  if (connect()) return;
  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    if (connect() || attempts >= 80) clearInterval(timer);
  }, 250);
})();
